import { render, staticRenderFns } from "./AssignmentTile.vue?vue&type=template&id=2a6d6d92&scoped=true&"
import script from "./AssignmentTile.vue?vue&type=script&lang=js&"
export * from "./AssignmentTile.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTile.vue?vue&type=style&index=0&id=2a6d6d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d6d92",
  null
  
)

export default component.exports